import { FC } from "react";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import RechargeTriggerButton from "./RechargeTriggerButton";
import RechargeConfirmation, { RechargeValues } from "./RechargeConfirmation";
import RechargeResultStep from "./RechargeResultStep";

type Props = RechargeValues & {
  triggerLabel?: string;
  isOpen: boolean;
  isLoading: boolean;
  error: any;
  data: any;
  handleOpen: () => void;
  handleSubmit: () => void;
  handleCancel: () => void;
  handleBack: () => void;
};

const RechargeButtonWeb: FC<Props> = ({
  triggerLabel,
  isOpen,
  isLoading,
  error,
  data,
  handleOpen,
  handleSubmit,
  handleCancel,
  handleBack,
  ...summary
}) => {
  const { t } = useTranslation();
  const hasResult = !!error || !!data;

  return (
    <>
      <RechargeTriggerButton onClick={handleOpen} label={triggerLabel} />

      <Modal
        open={isOpen}
        onCancel={handleCancel}
        footer={null}
        width={400}
        title={hasResult ? null : t("Topup.mobileRecharge")}
        classNames={{
          container: "p-0! rounded-md! rounded-s-xl!",
          body: "p-0!",
          title: "p-4! shadow-sm!",
        }}
      >
        {hasResult ? (
          <RechargeResultStep error={error} onBack={handleBack} onClose={handleCancel} />
        ) : (
          <RechargeConfirmation {...summary} isLoading={isLoading} onConfirm={handleSubmit} onCancel={handleCancel} />
        )}
      </Modal>
    </>
  );
};

export default RechargeButtonWeb;
